import type { RouteRecordRaw } from "vue-router"
import { routePaths } from "../routePaths"
import {
  CX_CORE_FEATURES_ENUM,
  DGK_FEATURES_ENUM,
  DIGITAL_TWIN_FEATURES_ENUM
} from "@/common/util/featuresUtil"
import { guardedImport } from "@/router/guardedImport"

const meta = { isProtected: true }
const pages = routePaths.advanced.children

const advancedRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.advanced.path,
    name: routePaths.advanced.pathName,
    component: () => import("@/layout/AbstractRouteView.vue"),
    redirect: { name: pages.policies.pathName },
    meta,
    children: [
      {
        path: pages.policies.path,
        name: pages.policies.pathName,
        component: () => import("@/modules/govern/policies/pages/Policies.vue"),
        meta
      },
      {
        path: pages.contractAgreements.path,
        name: pages.contractAgreements.pathName,
        component: () => import("@/modules/govern/agreements/pages/ContractAgreements.vue"),
        meta
      },
      {
        path: pages.contractDefinitions.path,
        name: pages.contractDefinitions.pathName,
        component: () =>
          import("@/modules/govern/contractDefinitions/pages/ContractDefinition.vue"),
        meta
      },
      {
        path: pages.assets.path,
        name: pages.assets.pathName,
        component: guardedImport(
          DGK_FEATURES_ENUM.ASSETS,
          () => import("@/modules/provide/assets-overview/pages/AssetsPage.vue")
        ),
        meta
      },
      {
        path: pages.simulateOffers.path,
        name: pages.simulateOffers.pathName,
        component: guardedImport(
          DGK_FEATURES_ENUM.OFFER,
          () => import("@/modules/provide/simulate-offers/pages/SimulateCatalog.vue")
        ),
        meta
      },
      {
        // Not in the menu; reached from the "offer published" screen
        path: pages.uploadHistory.path,
        name: pages.uploadHistory.pathName,
        component: () => import("@/modules/provide/upload-history/pages/UploadHistory.vue"),
        meta
      },
      {
        path: pages.connectors.path,
        name: pages.connectors.pathName,
        component: () => import("@/modules/govern/connectors/pages/Connectors.vue"),
        meta
      },
      {
        path: pages.processLogs.path,
        name: pages.processLogs.pathName,
        component: guardedImport(
          CX_CORE_FEATURES_ENUM.JOBS,
          () => import("@/modules/monitor/jobs/pages/Jobs.vue")
        ),
        meta
      },
      {
        path: pages.providerTwinBrowser.path,
        name: pages.providerTwinBrowser.pathName,
        component: guardedImport(
          DIGITAL_TWIN_FEATURES_ENUM.BROWSE,
          () => import("@/modules/provide/digital-twin-browser/pages/DigitalTwinBrowser.vue")
        ),
        meta
      },
      {
        path: pages.consumerTwinBrowser.path,
        name: pages.consumerTwinBrowser.pathName,
        component: guardedImport(
          DIGITAL_TWIN_FEATURES_ENUM.BROWSE,
          () => import("@/modules/consume/digital-twin-browser/pages/DigitalTwinBrowserConsume.vue")
        ),
        meta
      }
    ]
  }
]

export default advancedRoutes
